import React, { Component } from 'react'
import { Modal as ModalRouter } from 'react-router-modal'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobSiteDriverRequestActions'
import { actions as driverRequestTemplatesActions } from '../../../redux/modules/jobFunctions/driverRequestTemplatesActions'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import moment from 'moment'
import _ from 'lodash'
import ReactTable from 'react-table'
import { Form, Icon, message, Tooltip } from 'antd'
import { filterCaseInsensitive, convertToOption, getModalId } from '../../../util'
import JobSiteDriverRequestModal from './JobSiteDriverRequestModal'
import history from '../../../history'

const propTypes = {}

class JobSiteDriverRequests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      currentRevisionNumberPrint: 1
    }
  }

  componentDidMount() {
    this.props.driverRequestsRefresh({
      jobId: this.props.jobId,
      next: payload => {
        this.setState(
          {
            contentData:
              payload.data && payload.data.find(d => String(d.id) === String(this.state.currentId))
          },
          () => {
            this.props.getAuditRevisions({
              targetId: this.state.currentId,
              table: 'driver_request'
            })
            this.props.getAttachments({
              driverRequestId: this.state.currentId
            })
            this.props.getDriverRequestTemplates()
            if (this.state.currentId !== 0) {
              this.props.getAuditRevisions({
                targetId: this.state.currentId,
                table: 'driver_request'
              })
              this.props.getAttachments({
                driverRequestId: this.state.currentId
              })
            }
          }
        )
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.driverRequestTemplatesActions.driverRequestTemplates !==
      prevProps.driverRequestTemplatesActions.driverRequestTemplates
    ) {
      this.setState({
        templateOptions: convertToOption(
          this.props.driverRequestTemplatesActions &&
            this.props.driverRequestTemplatesActions.driverRequestTemplates &&
            this.props.driverRequestTemplatesActions.driverRequestTemplates.data
        )
      })
    }

    // update the current version for printing
    if (prevProps.auditActions.loading !== this.props.auditActions.loading) {
      const revisions = _.get(this.props, 'auditActions.revisions.data')
      if (revisions && revisions.length > 0) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].revision
        })
      } else {
        this.setState({
          currentRevisionNumberPrint: 1
        })
      }
    }
  }

  handleRowClick = row => {
    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'driver_request'
    })
    this.props.getAttachments({
      driverRequestId: row.id
    })
    this.setState(
      {
        currentId: row.id,
        contentData: row
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/driver-requests/modal/${row.id}`)
      }
    )
  }

  handleAddButton = () => {
    this.setState(
      {
        currentId: 0,
        contentData: null
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        this.props.history.push(`/jobView/${jobId}/${jobType}/driver-requests/modal/0`)
        this.forceUpdate() // Since we are using window.location.href, we need this workaround to make it work
      }
    )
  }

  redirectToDriverRequests = () => {
    const { jobType, jobId } = this.props.match.params
    this.setState({
      saving: false
    })
    history.push(`/jobView/${jobId}/${jobType}/driver-requests/`)
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0 }, this.redirectToDriverRequests)
  }

  getSelectedTemplate = value => {
    const driverRequestTemplates = _.get(
      this.props,
      'driverRequestTemplatesActions.driverRequestTemplates.data'
    )
    const selectedTemplate = driverRequestTemplates.find(template => template.name === value)
    return selectedTemplate ? +selectedTemplate.id : +value
  }

  handleCreate = () => {
    const form = this.props.form
    const self = this
    this.setState(
      {
        saving: true
      },
      () => {
        form.validateFields((err, values) => {
          if (err) {
            return
          }
          Object.keys(values).forEach(function(key, value) {
            if (key === 'requested_date' || key === 'needed_by_date') {
              if (moment(values[key]).isValid()) {
                values[key] = values[key].format('YYYY-MM-DD hh:mm:ss')
              } else {
                values[key] = null
              }
            }
            if (key === 'completed') {
              if (values[key] === 1) {
                if (self.state.contentData.completed === 0) {
                  values.completed_date = moment().format('YYYY-MM-DD hh:mm:ss')
                }
              }
            }
          })

          values.driver_request_template_id = values.driver_request_template_id
            ? this.getSelectedTemplate(values.driver_request_template_id)
            : null

          if (this.state.currentId === 0) {
            this.props.createDriverRequest({
              jobId: this.props.jobId,
              content: values,
              userId: this.props.user.userId
            })
          } else {
            this.props.updateDriverRequest({
              jobId: this.props.jobId,
              driverRequestId: this.state.currentId,
              content: values,
              userId: this.props.user.userId
            })
          }

          form.resetFields()
          message.success('Changes saved.')
          this.setState({ contentData: null, currentId: 0 }, this.redirectToDriverRequests)
        })
      }
    )
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteDriverRequest({
      jobId: this.props.jobId,
      driverRequestId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState(
      {
        contentData: null,
        currentId: 0
      },
      this.redirectToDriverRequests
    )
  }

  handlePrint = () => {
    this.props.driverRequestReport({
      jobId: this.props.jobId,
      driverRequestId: this.state.currentId
    })
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'driver_request')
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('driverRequestId', this.state.currentId)
    this.props.uploadAttachment({
      formData: formData,
      driverRequestId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      driverRequestId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      driverRequestId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleTemplateChange = event => {
    const form = this.props.form
    const selectedTemplate = this.props.driverRequestTemplatesActions.driverRequestTemplates.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedTemplate.length > 0) {
      form.setFieldsValue({
        requested_by: selectedTemplate[0].requested_by,
        point_of_contact: selectedTemplate[0].point_of_contact,
        special_conditions: selectedTemplate[0].special_conditions,
        description: selectedTemplate[0].description
      })
    }
  }
  handleRevisionChange = value => {
    const form = this.props.form
    const revisionsObject = this.props.auditActions.revisions.data.find(x => x.id === value)
    const revisions = JSON.parse(revisionsObject.json_patch)
    const revisionNumber = revisionsObject.revision

    // set revision numner for printing
    this.setState({
      currentRevisionNumberPrint: revisionNumber
    })

    let changes = {}
    revisions.forEach(revision => {
      const fieldName = revision.path.substring(1, revision.path.length)

      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        const isDateField = fieldName === 'requested_date' || fieldName === 'needed_by_date'

        changes[fieldName] = isDateField ? moment(revision.value) : revision.value
      }
    })

    form.setFieldsValue(changes)
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  handleSelectedTemplate = templateId => {
    const { templateOptions } = this.state
    let selectedTemplate = null
    if (templateOptions) {
      selectedTemplate = templateOptions.find(template => template.value === templateId)
    }
    return selectedTemplate ? selectedTemplate.text : null
  }

  render() {
    const { contentData, templateOptions, currentRevisionNumberPrint } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form

    const revisions =
      this.props.auditActions &&
      this.props.auditActions.revisions &&
      this.props.auditActions.revisions.data

    const loadingRevision = this.props.auditActions && this.props.auditActions.loading

    if (!this.props.jobSiteDriverRequestActions.jobSiteDriverRequests) {
      return <Loader />
    }
    return (
      <div>
        {this.shouldRenderModal() && (
          <ModalRouter
            path="/job/:jobId/:jobType/job_site_driver_requests/edit"
            exact
            component={JobSiteDriverRequestModal}
            props={{
              loadingRevision,
              contentData,
              templateOptions,
              currentRevisionNumberPrint,
              uploadProps,
              getFieldDecorator,
              revisions,
              handleSelectedTemplate: this.handleSelectedTemplate,
              handleCancel: this.handleCancel,
              handleCreate: this.handleCreate,
              jobSiteDriverRequestActions: this.props.jobSiteDriverRequestActions,
              handleTemplateChange: this.handleTemplateChange,
              handleRevisionChange: this.handleRevisionChange,
              attachmentDetailsVisible: this.state.attachmentDetailsVisible,
              confirmDelete: this.confirmDelete,
              cancelDelete: this.cancelDelete,
              attachmentName: this.state.attachmentName,
              attachmentDescription: this.state.attachmentDescription,
              onDescriptionChange: this.onDescriptionChange,
              handleUpdateAttachmentDescription: this.handleUpdateAttachmentDescription,
              confirmAttachmentDelete: this.confirmAttachmentDelete,
              currentId: this.state.currentId,
              handleAttachmentRowClick: this.handleAttachmentRowClick,
              uploadAttachment: this.uploadAttachment
            }}
          />
        )}
        <div className="jobsBar">
          Driver Requests
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Request
            </div>
          </div>
        </div>
        {this.props.jobSiteDriverRequestActions.jobSiteDriverRequests && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteDriverRequestActions.jobSiteDriverRequests.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Completed',
                    className: 'textAlignCenter',
                    Cell: row => {
                      if (!row.original.completed || row.original.completed === 0) {
                        return <Icon type="close-circle" />
                      }
                      if (row.original.completed === 1) {
                        return <Icon type="check-circle-o" />
                      }
                    },
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Number',
                    className: 'textAlignCenter',
                    accessor: 'number',
                    maxWidth: 70,
                    filterable: false
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Completed Date',
                    id: 'completed_date',
                    accessor: d => {
                      if (moment(d.completed_date).isValid()) {
                        return moment(d.completed_date, 'YYYY-MM-DD hh:mm:ss').format(
                          'M/D/YYYY h:mm:ssa'
                        )
                      } else {
                        return 'Not yet complete'
                      }
                    },
                    maxWidth: 200
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                    maxWidth: 200
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                    maxWidth: 200
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (
  { jobSiteDriverRequestActions, driverRequestTemplatesActions, auditActions },
  ownProps
) => ({
  jobSiteDriverRequestActions,
  driverRequestTemplatesActions,
  auditActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, auditActions, driverRequestTemplatesActions, actions),
    dispatch
  )
})

JobSiteDriverRequests.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteDriverRequests))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteDriverRequests.js